import { render, staticRenderFns } from "./UserPosAdd.vue?vue&type=template&id=83c984c8&scoped=true"
import script from "./UserPosAdd.vue?vue&type=script&lang=js"
export * from "./UserPosAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c984c8",
  null
  
)

export default component.exports